import React, { Fragment, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import DialogContent from "@material-ui/core/DialogContent";
import Input from "Components/Input/Input";
import Grid from "@material-ui/core/Grid";
import * as R from "ramda";
import Translator from "Languages/Utility/Translator";
import { editShisheGroup, GetAllShisheGroup } from "Stores/actions";
import { read } from "Helpers/LocalStorage";
import { DialogActions } from "@material-ui/core";
import MuiButton from "Components/MuiButton/MuiButton";
import { useTranslation } from 'react-i18next';
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import * as Icons from "react-bootstrap-icons";

export default function EditShisheGroupManage({ row }) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const [change, setChange] = useState(false);
  const { shisheGroupPagination } = useSelector((state) => ({
    shisheGroupPagination: state.shishe.shisheGroupPagination,
  }));
  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({ nameshishe: true });
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [controls, setControls] = useSetState({
    shisheGroupName: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
    }
  });

  const onEnter = async () => {
    setControls({ shisheGroupName: { value: row.Name } });
  };

  const handleDialog = () => setOpenDialog(!openDialog);

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
    setChange(true);
  }

  const onFinish = async (e) => {
    setLoading(true);
    e.preventDefault();
    if(change) {
      if (
        !R.isEmpty(formValid) &&
        Object.values(formValid).every((item) => item === true)
      ) {
        const { shisheGroupName } = controls;
        try {
          const data = {
            Id: +row.Id,
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Name: convertToEnglishNumber(shisheGroupName.value),
          };
          await dispatch(editShisheGroup(data));
          await dispatch(GetAllShisheGroup({
            KeyUser: read("userKey"),
            KeyGroup: read("groupKey"),
            Limit: shisheGroupPagination.Limit,
            Page: shisheGroupPagination.Page,
          }));
        } catch (err) {
          console.error('[catch error]', err)
        }
      }
    } else {
      handleDialog();
    }
    setLoading(false);
  }
  
  const onExit = () => {
    setOpenDialog(false);
  }

  return (
    <>
      <ActionFormatter
        title={<Translator id="virayesh" />}
        icon={<Icons.Pencil size={17} />}
        className="warning-fill"
        onClick={handleDialog}
        disabled={
          (row.IsG && read("StypeU") !== "1") ||
            read("mahsoleShisheGroupRules")?.accessUpdate === false || row.Disable
        }
      />
      <Dialog
        dir={direction}
        open={openDialog}
        TransitionProps={{
          onEnter: onEnter,
          onExit: onExit
        }}
        onClose={handleDialog}
        fullWidth
        maxWidth="xs"
      >
        <BackDropLoading loading={loading} />
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p>{<Translator id={"editShisheGroup"} />}</p>
          </div>
          <DialogContent>
            <Grid container xs={12} className="mt-1">
              {Object.keys(controls).map((key) => {
                  return (
                      <Fragment key={key}>
                      {controls[key].type === "text" && (
                          <Grid item xs={12} className="px-2">
                              <Input
                                  name={key}
                                  setValue={setValue.bind(this)}
                                  validation={controls[key].validation}
                                  placeholder={t(key)}
                                  label={<Translator id={key} />}
                                  type="text"
                                  value={controls[key].value}
                              />
                          </Grid>
                      )}
                    </Fragment>
                  );
              })}
            </Grid>
          </DialogContent>
          <DialogActions>
            <MuiButton
              color="primary"
              type="submit"
              title={<Translator id="button_save" />}
              disabled={loading}
            />
            <MuiButton
              onClick={handleDialog}
              title={<Translator id="enseraf" />}
              disabled={loading}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}
